import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { selectedModelState } from '../../../recoil/atoms';
import styles from './style.module.css';
import BtnWithTip from '../../../compoenets/BtnWithTip';
import ToggleSwitch from '../../../compoenets/ToggleSwitch';
import roundIcon from '../../../assets/stack_motion.svg'
import baseIcon from '../../../assets/box_motion.svg'

export default function Header({className,onClickLineage,isLineage}){
    const [selectedModel, setSelectedModel]=useRecoilState(selectedModelState);
    const [isBase,setIsBase]=useState(selectedModel.modelId===selectedModel.parentId);
    const [isLinkCopy,setIsLinkCopy]=useState(false);
    const [roundSrc,setRoundSrc]=useState(null);
    const [baseSrc,setBaseSrc]=useState(null);

    useEffect(()=>{
        setIsBase(selectedModel.modelId===selectedModel.parentId)
        setRoundSrc(roundIcon+`?v=${Date.now()}`)
        setBaseSrc(baseIcon+`?v=${Date.now()}`)
    },[selectedModel])

    const handleShare=()=>{
      navigator.clipboard.writeText(`https://wsfe-`+process.env.REACT_APP_ENV+`kr.ngpdev.com/`+selectedModel.modelId)
      .then(()=>{
        setIsLinkCopy(true)
        setTimeout(() => {
            setIsLinkCopy(false);
        }, 1000);
      })
      .catch(err=>console.error('copy fail:',err))
    }

    return(
        <div className={`${styles['header']} ${className}`}>
            <div className={`${styles['header-left']} ${!isBase && styles['round-icon']}`}>
                {isBase
                ?baseSrc&&<img src={baseSrc}/>
                :roundSrc&&<img src={roundSrc}/>
                }
                <div className={styles['header-title']}>
                    <span>{isBase 
                    ? selectedModel.name 
                    :selectedModel.task?.roundNum===0
                    ? 'Inital Round'
                    : selectedModel.task?.roundNum + '/' + selectedModel.task?.maxRound + ' Round'}</span>
                    <div>
                        <p>
                            <span>Dataset</span>
                            <span>{selectedModel.dataset}</span>
                        </p>
                        <p>
                            <span>Type</span>
                            <span>
                                {isBase 
                                ? "Base Model" 
                                : (selectedModel.task?.testResult?"Test Model":"Round Model")
                                }
                            </span>
                        </p>
                        {!isBase&&<p>
                            <span>Task Name</span>
                            <span>{selectedModel.task?.taskName}</span>
                        </p>}
                    </div>
                </div>
            </div>
            <div className={styles['header-right']}>
                {/* <BtnWithTip 
                className={styles['header-btn-mini']} 
                // onClick={handleShare}
                defaultText={"New Task"}
                /> */}
                <BtnWithTip 
                className={styles['header-btn-mini']} 
                // onClick={handleShare}
                defaultText={"Model Download"}
                />
                <BtnWithTip 
                className={styles['header-btn-mini']} 
                onClick={handleShare}
                defaultText={"Copy Link"}
                changeText={isLinkCopy&&"Copy Done"}
                />
                {/* <button className={styles['header-new-task']}>+ New Task</button> */}
                <ToggleSwitch
                leftText="Info"
                rightText="Lineage"
                checked={isLineage?true:false}
                onChange={onClickLineage}
                />
            </div>
        </div>
    )

}